import { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./LoginPage.css"; // Reuse your existing styling
import APP_VERSION from "../version";

export default function ProfilePage({ currentUser, setCurrentUser }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!currentUser) {
      navigate("/login", { replace: true });
    }
  }, [currentUser, navigate]);

  const handleLogout = async () => {
    await fetch("/auth/logout", { credentials: "include" });
    setCurrentUser(null);
    navigate("/login", { replace: true });
  };

  const firstLogin = location.state?.firstLogin || false;

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Logo */}
        <img
          src="/campwithfriends-logo.png"
          alt="Camp With Friends Logo"
          style={{ width: "200px", marginBottom: "20px" }}
        />

        {/* Title */}
        <h2 style={{ marginBottom: "10px" }}>Profile</h2>

        {/* First login message */}
        {firstLogin && (
          <p style={{ marginBottom: "20px", fontSize: "16px" }}>
            Now let's get your profile set up, Camper!
          </p>
        )}

        {/* Button Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            marginTop: "30px",
          }}
        >
          <button className="profile-button" onClick={() => navigate("/your-crew")}>
            <div className="profile-button-content">
              <img src="/Crew-image.png" alt="Crew" className="profile-button-icon" />
              <div>Crew</div>
            </div>
          </button>

          <button className="profile-button" onClick={() => navigate("/your-rides")}>
            <div className="profile-button-content">
              <img src="/Rides-image.png" alt="Rides" className="profile-button-icon" />
              <div>Rides</div>
            </div>
          </button>

          <button className="profile-button" onClick={() => navigate("/your-gear")}>
            <div className="profile-button-content">
              <img src="/gear-image.png" alt="Gear" className="profile-button-icon" />
              <div>Gear</div>
            </div>
          </button>

          <button className="profile-button" onClick={() => navigate("/your-groups")}>
            <div className="profile-button-content">
              <img src="/groups-image.png" alt="Groups" className="profile-button-icon" />
              <div>Groups</div>
            </div>
          </button>
        </div>

        {/* Home Button */}
        <button
          className="home-button"
          onClick={() => navigate("/")}
          style={{ marginTop: "30px", width: "100%" }}
        >
          Home
        </button>

        {/* Footer */}
        <div
          className="version-text"
          style={{
            marginTop: "20px",
            fontSize: "12px",
            color: "#ccc",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span>
            Version: <strong>{APP_VERSION}</strong>
          </span>
          <span>
            <button onClick={handleLogout} className="contact-link" style={{ marginRight: "16px" }}>
              Logout
            </button>
            <Link to="/contact" className="contact-link">Contact us</Link>
          </span>
        </div>
      </div>
    </div>
  );
}
